import GenericFormFooterComponent from "./forms/GenericFormFooterComponent";
import IconsPath from '../assets/icons/index'
import LanguageTranslator from "../locals/LanguageTranslator";

const GenericConfirmationModal = ({ closeModal, buttons, labelComponent, message, icon, headerComponent, extraClass, spreadFormFotterExtraClass }) => {

	return (
		<div className={`generic-confirmation-modal w-full h-full relative ${extraClass}`}>
			<div className="gcm-head flex items-center justify-between py-2.5 px-[15px]">
				{icon ? <div className="ncmt-img">
					{icon && typeof icon === 'function' ? icon() : icon}
				</div> : <div></div>}
				<button type="button" onClick={closeModal} ><IconsPath.ModalCloseIcon /></button>
			</div>
			{headerComponent && typeof (headerComponent) == "function" ? headerComponent() : headerComponent}
			<div className={`gcm-body block h-[calc(100%-105px)] py-2.5 px-[15px] overflow-auto bg-white`}>
				{labelComponent && typeof labelComponent === 'function' ? labelComponent() : <LanguageTranslator tag='h3' className='text-base font-bold'>{labelComponent}</LanguageTranslator>}
				{message && typeof message === 'function' ? message() : message}
			</div>
			<GenericFormFooterComponent
				spreadFormFotterExtraClass={spreadFormFotterExtraClass || ""}
				buttons={buttons}
			/>
		</div>
	);
};

export default GenericConfirmationModal;
